import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderTabService } from '../../shared/components/header-tabs/header-tab.service';

@Component({
    selector: 'app-booking-tabs',
    templateUrl: './booking-tabs.component.html',
    styleUrls: ['./booking-tabs.component.scss'],
    standalone: false
})
export class BookingTabsComponent implements OnInit {
  routes: object[];
  isSelected = false;
  isResponsive = false;

  constructor(
    private router: Router,
    private headerTabService: HeaderTabService
  ) {
    this.routes = [
      { label: 'Centros de trabajo', link: '/booking/locations', enable: true },
      { label: 'Reservas', link: '/booking/bookings', enable: true },
      { label: 'Calendario', link: '/booking/calendar', enable: true },
      { label: 'Informes', link: '/booking/reports', enable: true },
    ];
  }

  ngOnInit() {
    this.headerTabService.onEventSubject.subscribe(result => {
      const event = result.event;

      switch (event) {
        case 'on-select-tab':
          this.isSelected = true;
          break;
        case 'on-select-back':
          this.isSelected = false;
          break;
        case 'on-change-responsive':
          this.isResponsive = result.isResponsive;
          break;
      }
    });
  }

  onBack() {
    this.isSelected = false;
    this.headerTabService.onEvent({ event: 'on-select-back' });
  }
}
